/* ribogrow: show every ® as a small superscript in one font (Flo 14.10.2026).
   Wraps "®" in visible text nodes with <sup class="rg-reg"> (style in rg-ui.css). The texts stored in Shopify
   stay unchanged (alt texts, SEO, feeds, e-mails). Also handles content added later (cart drawer, reviews, labels). */
(function () {
  var REG = '®';
  var SKIP = /^(script|style|noscript|textarea|input|select|option|title|svg|code|pre|iframe|template)$/i;
  function skipped(el) {
    for (; el && el !== document.body; el = el.parentNode) {
      if (el.nodeType !== 1) continue;
      if (SKIP.test(el.nodeName) || el.isContentEditable || el.classList.contains('rg-reg')) return true;
    }
    return false;
  }
  function wrap(node) {
    var t = node.nodeValue, i = t ? t.indexOf(REG) : -1;
    if (i < 0 || !node.parentNode || skipped(node.parentNode)) return;
    var frag = document.createDocumentFragment(), last = 0;
    while (i >= 0) {
      if (i > last) frag.appendChild(document.createTextNode(t.slice(last, i)));
      var s = document.createElement('sup');
      s.className = 'rg-reg';
      s.textContent = REG;
      frag.appendChild(s);
      last = i + 1;
      i = t.indexOf(REG, last);
    }
    if (last < t.length) frag.appendChild(document.createTextNode(t.slice(last)));
    node.parentNode.replaceChild(frag, node);
  }
  function scan(root) {
    if (!root) return;
    if (root.nodeType === 3) { wrap(root); return; }
    if (root.nodeType !== 1 || skipped(root) || (root.textContent || '').indexOf(REG) < 0) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n, list = [];
    while ((n = w.nextNode())) if (n.nodeValue.indexOf(REG) >= 0) list.push(n);
    list.forEach(wrap);
  }
  function start() {
    scan(document.body);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'characterData') wrap(m.target);
        else for (var k = 0; k < m.addedNodes.length; k++) scan(m.addedNodes[k]);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
